/**
 * Dedicated-Server Fixture.
 */

export function availableDeviceFixture({ role }) {
  return {
    device: {
      id: 42,
      name: 'enhance-web-02',
      role,
      role_name: 'Enhance Webserver',
      site: 'fra1',
      status: 'active',
      primary_ip: '10.20.30.42',
      enhance_server_id: 'srv-002',
      dedicated_to_customer_id: null,
    },
  };
}

export function customerDevicesFixture(customerId) {
  return {
    devices: [
      {
        id: 41,
        name: 'enhance-web-01',
        role: 'enhance-webserver',
        role_name: 'Enhance Webserver',
        site: 'fra1',
        status: 'active',
        primary_ip: '10.20.30.41',
        enhance_server_id: 'srv-001',
        dedicated_to_customer_id: customerId,
      },
    ],
  };
}
